import { BaseModel } from './base-model.interface';
import BlockModel from './block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';
import { Segment } from './segment.interface';

export interface ParagraphCtaModel extends BaseModel {
  variables?: { [key: string]: string} | ParagraphCtaVariables;
}

export interface ParagraphCtaVariables {
  IntroText: string;
  MainCtaLink: string;
  MainCtaText: string;
  MainCtaLinkSegmentRegex: string;
}

export class ParagraphCtaInitVariables implements ParagraphCtaVariables {
  IntroText = '';
  MainCtaLink = '';
  MainCtaText = '';
  MainCtaLinkSegmentRegex = '';
}

export class ParagraphCtaInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new ParagraphCtaInitVariables();
    this.variables = {...initVars};
    this.notifications = [new NotificationInitVariables()];
  }
}
